import React, { FC, ReactNode } from 'react';

import { StyledPagePanel } from '../styled';

const PagePanel: FC<{ children: ReactNode }> = ({ children }) => (
  <StyledPagePanel data-page-panel>{children}</StyledPagePanel>
);

export default PagePanel;
